import React, { ReactNode } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from 'styled-components';
import NavigationBar from '@ui-parts/NavigationBar';
import Footer from '@ui-parts/Footer';
import useHandleLogout from '@functional/useHandleLogout';
import { HEADER } from '~/assets/styles/base';

const StyledBody = styled.div`
  min-height: 100vh;
  position: relative;
  padding-bottom: 60px;
  box-sizing: border-box;
`;

interface PrivatePageWrapperProps {
  children: ReactNode;
}

const PrivatePageWrapper = ({ children }: InferProps<PrivatePageWrapperProps>) => {
  const handleLogout = useHandleLogout({ isAdmin: true });

  return (
    <StyledBody data-testid="layouts-admin-privatePageWrapper">
      <NavigationBar
        bgColor={HEADER.navigationBar.bgColor.admin}
        height={HEADER.navigationBar.height}
        isHiddenNavButtons
        handleLogout={handleLogout}
        isAdmin
      />
      {children}
      <Footer />
    </StyledBody>
  );
};

PrivatePageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivatePageWrapper;
